var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},_vm._l((_vm.socials),function(social,i){return _c('a',{key:i,staticClass:"mx-2",attrs:{"href":social.url,"title":`${social.network} profile`}},[_c('v-icon',{domProps:{"textContent":_vm._s(social.icon)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }